export default "/images/claritick-icon-1.svg?e9099eac70f08eb0b8e06044431f21f5";